import React, { PropTypes } from 'react';
import { Form } from 'semantic-ui-react';

export const RadioOption = ({
  title,
  name,
  value,
  onChange,
  width,
  customTrueLabel,
  customFalseLabel,
  customNoneLabel,
  readOnly,
}) => {
  const onCheckedChange = (evt, change) => {
    let value = undefined;
    if (change.value === 'true') {
      value = true;
    } else if (change.value === 'false') {
      value = false;
    }

    onChange(evt, { ...change, value });
  };

  return (
    <Form.Field width={width}>
      <label>{title}</label>
      <Form.Group inline>
        <Form.Radio
          label={customTrueLabel || 'Oui'}
          name={name}
          value="true"
          checked={value === true}
          onChange={onCheckedChange}
          width={2}
          readOnly={readOnly}
        />
        <Form.Radio
          label={customFalseLabel || 'Non'}
          name={name}
          value="false"
          checked={value === false}
          onChange={onCheckedChange}
          width={2}
          readOnly={readOnly}
        />
        <Form.Radio
          label={customNoneLabel || 'Je ne sais pas'}
          name={name}
          value="undefined"
          checked={value !== true && value !== false}
          onChange={onCheckedChange}
          width={4}
          readOnly={readOnly}
        />
      </Form.Group>
    </Form.Field>
  );
};

RadioOption.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  customTrueLabel: PropTypes.string,
  customFalseLabel: PropTypes.string,
  customNoneLabel: PropTypes.string,
};

export default RadioOption;



// WEBPACK FOOTER //
// ./src/modules/common/components/RadioOption.js